// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {BookStatus} from 'redux/v1/bookStatus/actions';
import type {BookStatusState} from 'redux/v1/bookStatus/BookStatusState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {GET_JOURNEY_BOOKSTATUS} from 'redux/v1/bookStatus/actions';
import {bookStatusState} from 'redux/v1/V1State';

export const initialState: BookStatusState = {
  loading: false,
  bookingInProgress: false,
  booked: false,
};

const actionCreators: ActionHandlers<BookStatusState> = {
  [PENDING(GET_JOURNEY_BOOKSTATUS)]: (state: BookStatusState) => ({
    ...state,
    loading: true,
    error: undefined,
  }),
  [SUCCESS(GET_JOURNEY_BOOKSTATUS)]: (
    state: BookStatusState,
    action: BookStatus
  ) => ({
    ...state,
    loading: false,
    success: true,
    bookingInProgress: action.data.bookingInProgress,
    booked: action.data.booked,
  }),
  [ERROR(GET_JOURNEY_BOOKSTATUS)]: (state: BookStatusState, action: any) => ({
    ...state,
    loading: false,
    success: false,
    error: action.error,
  }),
};

// $FlowFixMe
export const bookStatusReducer: Reducer<BookStatusState> =
  // $FlowFixMe
  createReducerUsingActionHandlers<BookStatusState>(
    initialState,
    actionCreators
  );

export const isInProgress: Selector<boolean, any> = createSelector(
  // $FlowFixMe
  bookStatusState,
  (state: BookStatusState) => state.bookingInProgress
);

export const isBooked: Selector<boolean, any> = createSelector(
  // $FlowFixMe
  bookStatusState,
  (state: BookStatusState) => state.booked
);

export const hasError: Selector<boolean, any> = createSelector(
  // $FlowFixMe
  bookStatusState,
  (state: BookStatusState) => state.error !== undefined
);
